import { Deserializable } from '../protocols/deserializable';
import { FundType } from './fund-type';

export class MemberAccountFundDetails implements Deserializable {
  public fundId!: number;
  public fund!: FundType;
  public units!: number;
  public fundUnitPrice!: number;
  public totalBalance!: number;

  public onDeserialize(): void {
    if (this.fund) {
      this.fund = window?.injector?.Deserialize.instanceOf(FundType, this.fund);
    }
  }
}
